@use "~theme/typography";
@use "~theme/breakpoints";

.retiring {
  font-size: 10px;
  background: var(--blue-01);
  border-radius: 4px;
  color: white;
  display: table;
  height: 20px;
  padding: 0px 5px;
  margin-top: 0px;
}

.selectedDoctor, .review {
    margin-top: 0px;
}

.success,  .successNew {
    margin-top: -12px;
    @include breakpoints.desktop {
        margin-top: -7px;
    }
}


.upcomeAppointment {
    right: 20px;
    position: absolute;
    margin-top: 15px;
}
